import { PostTypes } from 'constants/postTypes'
import { DocumentData, Query, query, where } from 'firebase/firestore'

import { PostFilter } from 'types/post'

export const formatQueryFilters = (baseQuery: Query<DocumentData>, filter?: PostFilter) => {
  if (!filter) return baseQuery

  let resultQuery = baseQuery
  if (filter === 'Free') {
    resultQuery = query(
      resultQuery,
      where('type', '==', PostTypes.WORKOUT),
      where('isPremium', '==', false),
    )
  }
  if (filter === 'Premium') {
    resultQuery = query(
      resultQuery,
      where('isPremium', '==', true),
      where('type', '==', PostTypes.WORKOUT),
    )
  }
  if (filter === 'Simple') {
    resultQuery = query(resultQuery, where('type', '!=', PostTypes.WORKOUT))
  }
  if (filter === 'Workouts') {
    resultQuery = query(resultQuery, where('type', '==', PostTypes.WORKOUT))
  }

  return resultQuery
}
